import { render, staticRenderFns } from "./create-edit-obj-cpoy.vue?vue&type=template&id=df8761b4&scoped=true&"
import script from "./create-edit-obj-cpoy.vue?vue&type=script&lang=js&"
export * from "./create-edit-obj-cpoy.vue?vue&type=script&lang=js&"
import style0 from "./create-edit-obj-cpoy.vue?vue&type=style&index=0&id=df8761b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8761b4",
  null
  
)

export default component.exports